<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="560px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <div class="row">
              <div class="col-md-12">
                <v-combobox
                  v-model="item.emitter"
                  data-vv-as="emisor"
                  name="emitter"
                  item-text="name"
                  item-value="id"
                  :items="emitters"
                  label="Emisor*"
                  autocomplete="off"
                  v-validate="'required|combobox_required'"
                  :disabled="isViewModal() || item.id > 0"
                  return-object
                  @change="loadParents"
                ></v-combobox>
                <span class="red--text">{{ errors.first("emitter") }}</span>

                <v-text-field
                  data-vv-as="código"
                  label="Código*"
                  name="code"
                  v-model="item.code"
                  v-validate="'required'"
                  :disabled="isViewModal()"
                  placeholder="Ej: 5.1.03"
                ></v-text-field>
                <span class="red--text">{{ errors.first("code") }}</span>

                <v-text-field
                  data-vv-as="nombre"
                  label="Nombre*"
                  name="name"
                  v-model="item.name"
                  v-validate="'required'"
                  :disabled="isViewModal()"
                ></v-text-field>
                <span class="red--text">{{ errors.first("name") }}</span>

                <v-combobox
                  v-model="item.grupo"
                  data-vv-as="grupo"
                  name="grupo"
                  item-text="name"
                  item-value="id"
                  :items="grupos"
                  label="Grupo*"
                  autocomplete="off"
                  v-validate="'required|combobox_required'"
                  :disabled="isViewModal()"
                  return-object
                ></v-combobox>
                <span class="red--text">{{ errors.first("grupo") }}</span>

                <v-combobox
                  v-model="item.parent"
                  name="parent"
                  item-text="label"
                  item-value="id"
                  :items="parentsFiltrados"
                  label="Cuenta padre (opcional, mismo grupo)"
                  autocomplete="off"
                  clearable
                  :disabled="isViewModal()"
                  return-object
                ></v-combobox>

                <v-checkbox label="Imputable (recibe asientos)" :disabled="isViewModal()" v-model="item.imputable"></v-checkbox>
                <v-checkbox label="Habilitado" :disabled="isViewModal()" v-model="item.enabled"></v-checkbox>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import ConstantSections from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";

export default {
  mixins: [ModalGenericMixin],
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
    emitters: Array,
  },
  data() {
    return {
      accounts: [],
      grupos: [
        { id: 1, name: "Activo" },
        { id: 2, name: "Pasivo" },
        { id: 3, name: "Patrimonio Neto" },
        { id: 4, name: "Ingresos" },
        { id: 5, name: "Egresos" },
      ],
    };
  },
  computed: {
    // El padre debe ser del mismo grupo y distinto de la propia cuenta
    parentsFiltrados() {
      let arr = this.accounts;
      if (this.item.grupo && this.item.grupo.id) {
        arr = arr.filter((a) => a.grupo && a.grupo.id === this.item.grupo.id);
      }
      if (this.item.id > 0) {
        arr = arr.filter((a) => a.id !== this.item.id);
      }
      return arr;
    },
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog(val) {
      this.errors.clear();
      if (val) this.loadParents();
    },
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    loadParents() {
      if (!this.item.emitter || !this.item.emitter.id) {
        this.accounts = [];
        return;
      }
      generalService
        .filter({ enabled: "all", emitter: this.item.emitter.id }, ConstantSections.SECTION_ACCOUNTS)
        .then((response) => {
          this.accounts = response.result || [];
        });
    },
    createItem(e) {
      if (this.loading) return;
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();
          this.loading = true;
          this.service.setSection(ConstantSections.SECTION_ACCOUNTS);

          const payload = {
            id: this.item.id || null,
            code: this.item.code,
            name: this.item.name,
            grupo: this.item.grupo ? this.item.grupo.id : null,
            parent: this.item.parent ? { id: this.item.parent.id } : null,
            emitter: this.item.emitter ? { id: this.item.emitter.id } : null,
            imputable: this.item.imputable,
            enabled: this.item.enabled,
          };

          const call = this.item.id > 0 ? this.service.update(payload) : this.service.create(payload);
          call
            .then((response) => {
              if (response.status == true) {
                const verb = this.item.id > 0 ? "modifico" : "creo";
                this.$toast.success("La " + this.modal_title + " se " + verb + " correctamente.", "OK");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                this.$toast.error(response.msg || response.message, "Error");
              }
            })
            .catch(() => {
              this.$toast.error("Ocurrió un error al guardar.", "Error");
            })
            .finally(() => (this.loading = false));
        }
      });
    },
  },
};
</script>
